import random from 'toxilibs/random.js'
import Level from '../core/level.js'
import mathText from '../math_text.js'

const level = new Level({
    name: 'vector_x_coord',
    dependencies: [
        'levels_maths/simple_length'
    ]
})



function common (q, v) {

    v.name    = 'V'
    v.originX = v.originX || 0
    v.originY = v.originY || 0
    v.color   = '#F00'

    let geoScreen = q.addGeoScreen({
        noAxes: true,
        margin: 0.3
    })
    geoScreen.addVector(v)

    q.addText(mathText.vectorName(v) + '.x = ?')
    q.answer = v.x

}


level.addQuestion({
    generator: function (q) {
        common(q, {
            x: random.fairChoiceInt(1, 7, {name: 'x'}),
            y: random.fairChoiceInt(1, 4, {name: 'y'})
        })
    }
})


level.addQuestion({
    generator: function (q) {
        common(q, {
            x: random.fairChoiceInt(-6, -1, {name: 'x'}),
            y: random.fairChoiceInt(1, 4, {name: 'y'})
        })

    }
})



export default level

